import { createAction } from '@reduxjs/toolkit';

export const setErrorStatus = createAction<boolean>('error/setError');
export const setSuccessStatus = createAction<boolean>('success/setSuccess');
export const setErrorMessage = createAction<string>('error/setErrorMessage');
export const setErrorCatch = createAction<unknown>('error/setErrorCatch');
export const setInfoStatus = createAction<boolean>('info/setInfoStatus');
